var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.667,
    height: 106.4,
    viewBox: "0 0 88.667 106.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center",
    transform: "translate(-2 -0.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    "data-name": "Path 3599",
    d: "M46.1,106.409l-1.569-.7C42.787,104.946,2,86.525,2,53.169V24.246a13.225,13.225,0,0,1,9.093-12.555L46.333.009,81.574,11.691a13.225,13.225,0,0,1,9.093,12.555V53.169c0,38.025-41.177,52.114-42.932,52.7Zm1.231-97.1L14.9,20.061a4.4,4.4,0,0,0-3.032,4.185V53.169c0,24.357,28.551,40.157,35.675,43.717C54.653,94.027,82.8,80.935,82.8,53.169V24.246a4.4,4.4,0,0,0-3.032-4.185Z",
    transform: "translate(0 0.2)",
    fill: "#038f37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(24 28.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    "data-name": "Path 3601",
    d: "M18.578,25.156A12.578,12.578,0,1,0,6,12.578,12.578,12.578,0,0,0,18.578,25.156Zm0-20.964a8.385,8.385,0,1,1-8.385,8.385,8.385,8.385,0,0,1,8.385-8.385Z",
    transform: "translate(3.289)",
    fill: "#038f37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3602",
    "data-name": "Path 3602",
    d: "M21.867,14A18.888,18.888,0,0,0,3,32.867a2.1,2.1,0,1,0,4.193,0,14.674,14.674,0,1,1,29.349,0,2.1,2.1,0,0,0,4.193,0A18.888,18.888,0,0,0,21.867,14Z",
    transform: "translate(0 15.349)",
    fill: "#038f37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.eb3551de6a420f0a2f690e9926aaeb8d.svg";
export { ForwardRef as ReactComponent };